'use strict';

const EVENT_EXTRA_KEY_FOR_ROUTE_TO = "ROUTE_TO";

exports.EVENT_EXTRA_KEY_FOR_ROUTE_TO = EVENT_EXTRA_KEY_FOR_ROUTE_TO;
//# sourceMappingURL=constants.cjs.map
